import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ViewersDropdown = (props) => {
  const { onChange, name, defaultValue, width = "90%" } = props;

  const option = [
    {
      id: "1",
      label: "Private",
    },
    {
      id: "2",
      label: "Public",
    },
  ];

  const handleDropdownChange = (value) => {
    const selectedOption = option.find((item) => item.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    // Pass both value and label to the onChange handler
    onChange(name, value, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select Role"
      options={option}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={true}
      width={width}
      dropdowType={"ViewersDropdown"}
    />
  );
};

export default ViewersDropdown;
